export enum PaymentReminderDetailsRepeatType {
  Every = 'everyNDays',
  Once = 'once',
}
